export default "__VITE_ASSET__DDO64OOO__"